module.exports = __webpack_public_path__ + "static/media/bg_desert.8afafccb.mp3";